"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const Icon_1 = __importDefault(require("./Icon"));
function CalendarIcon(props) {
    return (react_1.default.createElement(Icon_1.default, Object.assign({}, props),
        react_1.default.createElement("path", { d: "m19.333,4.498h-1.725v-2.236h-1.828v2.236h-7.559v-2.236h-1.828v2.236h-1.726c-1.606,0-2.914,1.308-2.914,2.914v11.412c0,1.606,1.308,2.914,2.914,2.914h14.665c1.606,0,2.914-1.308,2.914-2.914V7.412c0-1.606-1.308-2.914-2.914-2.914Zm1.086,14.326c0,.599-.487,1.086-1.086,1.086H4.668c-.599,0-1.086-.487-1.086-1.086V7.412c0-.599.487-1.086,1.086-1.086h14.665c.599,0,1.086.487,1.086,1.086v11.412Z" }),
        react_1.default.createElement("circle", { cx: "6.79", cy: "10.652", r: "1.511" }),
        react_1.default.createElement("circle", { cx: "12", cy: "10.652", r: "1.511" }),
        react_1.default.createElement("circle", { cx: "17.211", cy: "10.652", r: "1.511" }),
        react_1.default.createElement("circle", { cx: "6.79", cy: "15.584", r: "1.511" }),
        react_1.default.createElement("circle", { cx: "12", cy: "15.584", r: "1.511" })));
}
exports.default = CalendarIcon;
